<template>
  <!--          <model @delete_model="delete_model(model.id)" v-for="model in models" :model="model"></model>-->
    <v-card >
      <v-card-title>
<!--        <edit-label-dialog @update_label="update_label":labels="labels" :item="editedItem" @close_modal="close_modal" v-if="dialog"></edit-label-dialog>-->
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          :label="$t('modellist.search')"
          single-line
          hide-details
        ></v-text-field>
        <v-checkbox
          v-model="show_archived"
          :label="$t('modellist.show_archived')"
          hide-details
          class="ml-4"
        ></v-checkbox>
      </v-card-title>
      <loader :loading="loading"></loader>
      <run-modal-modal v-if="show_run_modal_modal" :model="model_in_modal" @close_modal="close_modal"></run-modal-modal>
      <live-demo-url-dialog
        v-if="liveDemoPath"
        :path="liveDemoPath"
        @close="liveDemoPath = null"
      />
      <live-demo-export-dialog
        v-if="liveDemoExportMessage"
        :message="liveDemoExportMessage"
        @close="liveDemoExportMessage = null"
      />
      <model-download-link-dialog
        v-if="downloadLinkPath"
        :path="downloadLinkPath"
        @close="downloadLinkPath = null"
      />
      <train-log-modal
        v-if="trainLogModel"
        :job="trainLogJob"
        :model="trainLogModel"
        @close="closeTrainLog"
      />
      <delete-button @pressed="delete_selected_items" v-if="selected_model_ids.length > 0"></delete-button>
      <v-btn
        v-if="has_unarchived_selected"
        class="ma-2"
        text
        icon
        color="primary"
        x-small
        :title="$t('modellist.archive_selected')"
        @click="archive_selected_items"
      >
        <v-icon>mdi-archive</v-icon>
      </v-btn>
      <v-btn
        v-if="has_archived_selected"
        class="ma-2"
        text
        icon
        color="primary"
        x-small
        :title="$t('modellist.unarchive_selected')"
        @click="unarchive_selected_items"
      >
        <v-icon>mdi-archive-arrow-up</v-icon>
      </v-btn>
      <v-data-table
        v-model:page="page"
        v-model:items-per-page="itemsPerPage"
        :sort-by="[{ key: 'created_at', order: 'desc' }]"
        :search="search"
        :custom-filter="customFilter"
        :items="filter_models"
        @item-selected="item_selection_toggled"
        @toggle-select-all="toggle_select_all"
        show-select
        :headers="table_headers">
        <template v-slot:item.active="{ item }">
          <model-active :disabled="item.archived" @toggle_model_active="toggle_model_active" :model="item"></model-active>
        </template>
        <template v-slot:item.meta="{ item }">
          <model-meta :model="item"></model-meta>
        </template>
        <template v-slot:item.dataset="{ item }">
          <span :title="$t('modellist.dataset_hint')">
            {{ formatDatasetCount(item.training_set_asset_count) }}
            /
            {{ formatDatasetCount(item.validation_set_asset_count) }}
          </span>
        </template>
        <template v-slot:item.exports="{ item }">
          <div style="max-width: 200px;">
            <model-exports :model="item" @calibration-ready="$emit('models-changed')"></model-exports>
          </div>
        </template>
         <template v-slot:item.performance="{ item }">
           <model-performance-chip :threshold="threshold" :model="item"></model-performance-chip>
           <v-btn v-if="(is_admin || is_global_admin) && hide_sync_for_model[item.id] != true" icon @click="recalculate_confusion_matrix(item)" color="primary" x-small style="margin-left: 5px;">
            <v-icon>fas fa-sync</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn
            icon
            @click="openTrainLog(item)"
            color="primary"
            x-small
            :loading="trainLogLoadingId === item.id"
            :title="$t('models_and_train_configs.train_log_title')"
          >
            <v-icon>fas fa-chart-line</v-icon>
          </v-btn>
          <delete-button @pressed="delete_item(item)"></delete-button>
          <v-btn
            icon
            :href="bundle_download_url(item)"
            download
            color="primary"
            x-small
            :title="$t('modellist.download_bundle')"
          >
            <v-icon>fas fa-file-arrow-down</v-icon>
          </v-btn>
          <v-btn
            icon
            color="primary"
            x-small
            data-testid="model-public-download-link-btn"
            :title="$t('model_download.create_link')"
            :loading="downloadLinkLoadingId === item.id"
            @click="createDownloadLink(item)"
          >
            <v-icon>mdi-link-variant</v-icon>
          </v-btn>
          <v-btn icon @click="toggle_model_archived(item)" color="primary" x-small>
            <v-icon v-if="item.archived">mdi-archive-arrow-up</v-icon>
            <v-icon v-else>mdi-archive</v-icon>
          </v-btn>
          <v-btn icon @click="show_run_model_modal(item)" color="primary" x-small>
            <v-icon>far fa-circle-play</v-icon>
          </v-btn>
          <v-btn
            v-if="isLiveDemoModel(item)"
            icon
            color="primary"
            x-small
            data-testid="try-live-btn"
            :title="$t('live_demo.try_live')"
            :loading="liveDemoLoadingId === item.id"
            @click="createLiveDemo(item)"
          >
            <v-icon>mdi-cellphone-wireless</v-icon>
          </v-btn>
        </template>
        <template v-slot:top>
          <v-dialog v-model="dialog_delete" max-width="500px">
            <v-card>
              <v-card-title v-if="dialog_items_delete.length === 1">Are you sure you want to delete {{dialog_items_delete[0].name}}?</v-card-title>
              <v-card-title v-if="dialog_items_delete.length > 1">Are you sure you want to delete these models?</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="close_dialog">Cancel</v-btn>
                <v-btn color="primary" text @click="delete_item_for_real">OK</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>
      </v-data-table>
    </v-card>
</template>

<script>
import ModelMeta from "@/components/models/ModelMeta";
import ModelExports from "@/components/models/ModelExports";
import ModelActive from "@/components/models/ModelActive";
import dayjs from 'dayjs';
import RunModalModal from "@/components/run_model_modal/RunModelModal";
import ModelPerformanceChip from "@/components/models/ModelPerformanceChip";
import TrainLogModal from "@/components/models/TrainLogModal";
import LiveDemoUrlDialog from "@/components/models/LiveDemoUrlDialog.vue";
import LiveDemoExportDialog from "@/components/models/LiveDemoExportDialog.vue";
import ModelDownloadLinkDialog from "@/components/models/ModelDownloadLinkDialog.vue";
import DeleteButton from "@/components/form/DeleteButton.vue";
import Loader from "@/components/layout/loader.vue";
import CurrentUserMixin from "@/mixins/CurrentUserMixin";
import { vuetifyHeaders } from "@/utils/vuetifyHeaders";
import {
  jobHasTrainMetrics,
  modelHasTrainLogFile,
} from "@/utils/trainMetrics";
import { isClassificationModel } from "@/utils/modelExportTypes";

export default {
  name: "ModelList",
  components: {
    Loader,
    DeleteButton,
    ModelPerformanceChip,
    TrainLogModal,
    RunModalModal,
    ModelActive,
    ModelMeta,
    ModelExports,
    LiveDemoUrlDialog,
    LiveDemoExportDialog,
    ModelDownloadLinkDialog,
  },
  props: ['models', 'threshold'],
  data () {
    return {
      'selected_model_ids': [],
      'search': '',
      'dialog_delete': false,
      'dialog_items_delete': [],
      'item_name': 'model',
      'model_in_modal': false,
      'show_run_modal_modal': false,
      'loading': false,
      'hide_sync_for_model': {},
      'show_archived': false,
      page: 1,
      itemsPerPage: 5,
      trainLogJob: null,
      trainLogModel: null,
      trainLogLoadingId: null,
      liveDemoPath: null,
      liveDemoExportMessage: null,
      liveDemoLoadingId: null,
      downloadLinkPath: null,
      downloadLinkLoadingId: null,
    }
  },
  mixins: [CurrentUserMixin],
  methods: {
    isLiveDemoModel(model) {
      const t = model && String(model.type || '').toLowerCase();
      if (t === 'edgeyolo' || t === 'rtmdet' || t === 'rfdetr') {
        return true;
      }
      // FastAI / classification TFLite try-in-browser (issue #39).
      return isClassificationModel(model);
    },
    async createDownloadLink(model) {
      this.downloadLinkLoadingId = model.id;
      try {
        const result = await this.$api.model.createDownloadLink(model.id);
        if (!result || result.error) {
          await this.$store.dispatch(
            'snackbars/add_failed_snack',
            (result && result.error) || this.$t('model_download.create_failed'),
          );
          return;
        }
        if (result.status === 'ready' && (result.path || result.url)) {
          this.downloadLinkPath = result.path || result.url;
          return;
        }
        await this.$store.dispatch(
          'snackbars/add_failed_snack',
          this.$t('model_download.create_failed'),
        );
      } catch (e) {
        await this.$store.dispatch(
          'snackbars/add_failed_snack',
          (e && e.message) || this.$t('model_download.create_failed'),
        );
      } finally {
        this.downloadLinkLoadingId = null;
      }
    },
    async createLiveDemo(model) {
      this.liveDemoLoadingId = model.id;
      try {
        const result = await this.$api.model.createLiveDemo(model.id);
        if (!result || result.error) {
          await this.$store.dispatch(
            'snackbars/add_failed_snack',
            (result && result.error) || this.$t('live_demo.create_failed'),
          );
          return;
        }
        if (result.status === 'export_required') {
          this.liveDemoExportMessage = result.message || this.$t('live_demo.export_required');
          this.$emit('models-changed');
          return;
        }
        if (result.status === 'ready' && (result.path || result.url)) {
          this.liveDemoPath = result.path || result.url;
          return;
        }
        await this.$store.dispatch(
          'snackbars/add_failed_snack',
          this.$t('live_demo.create_failed'),
        );
      } catch (e) {
        await this.$store.dispatch(
          'snackbars/add_failed_snack',
          (e && e.message) || this.$t('live_demo.create_failed'),
        );
      } finally {
        this.liveDemoLoadingId = null;
      }
    },
    closeTrainLog() {
      this.trainLogJob = null;
      this.trainLogModel = null;
    },
    async openTrainLog(model) {
      this.trainLogLoadingId = model.id;
      try {
        const job = await this.$api.model.getTrainJob(model.id);
        const hasMetrics = job && jobHasTrainMetrics(job);
        const hasLogFile = modelHasTrainLogFile(model);
        if (!hasMetrics && !hasLogFile) {
          this.$store.dispatch(
            'snackbars/add_failed_snack',
            this.$t('models_and_train_configs.train_log_unavailable'),
          );
          return;
        }
        this.trainLogModel = model;
        this.trainLogJob = hasMetrics
          ? job
          : { id: 0, progress: 0, processed: 1, description: "{}" };
      } finally {
        this.trainLogLoadingId = null;
      }
    },
    item_selection_toggled(param) {
      let item = param.item;
      let value = param.value;
      if(value) {
        this.select_model(item)
      }
      else {
        this.unselect_model(item);
      }
    },
    select_model(model) {
      let index = this.selected_model_ids.indexOf(model.id);
      if(index === -1) {
        this.selected_model_ids.push(model.id);
      }
    },
    unselect_model(model) {
      let index = this.selected_model_ids.indexOf(model.id);
      if(index!==-1) {
        this.selected_model_ids.splice(index, 1);
      }
    },
    toggle_select_all(param) {
      let items = param.items;
      let value = param.value;

      if(value) {
        items.forEach(item=>{this.select_model(item)});
      }
      else {
        items.forEach(item=>{this.unselect_model(item)});
      }
    },
    close_modal() {
      this.show_run_modal_modal = false;
      this.model_in_modal = false
    },
    delete_item(item) {
      this.dialog_items_delete = [item];
      this.dialog_delete = true
    },
    delete_selected_items() {
      this['dialog_items_delete'] = this.models.filter(model => {
        return this.selected_model_ids.indexOf(model.id) !== -1;
      });
      this.dialog_delete = true
    },
    show_run_model_modal(item) {
      let model_id_index = this.models.indexOf(item);
      this.show_run_modal_modal = true;
      this.model_in_modal = this.models[model_id_index]
    },
    async recalculate_confusion_matrix(model) {
      this.hide_sync_for_model[model.id] = true;
      await this.$api.model.calculate_confusion_matrix(model.id);
      await this.$store.dispatch('snackbars/add_success_snack', 'Confusion matrix is being recalculated')
    },
    async set_model_archived(model, archived) {
      this.loading = true;
      try {
        let updated_model = archived
          ? await this.$api.model.archive(model.id)
          : await this.$api.model.unarchive(model.id);
        if(updated_model && updated_model.id) {
          Object.keys(updated_model).forEach((key)=>{
            model[key] = updated_model[key];
          });
        }
        else {
          model['archived'] = archived;
          if(archived) {
            model['active'] = false;
          }
        }
        if(archived && !this.show_archived) {
          this.unselect_model(model);
        }
      }
      finally {
        this.loading = false;
      }
    },
    async toggle_model_archived(model) {
      await this.set_model_archived(model, !model.archived);
    },
    async archive_selected_items() {
      let selected_models = this.selected_models.filter(model=>!model.archived);
      for(let i=0; i<selected_models.length; i++) {
        await this.set_model_archived(selected_models[i], true);
      }
      this.selected_model_ids = [];
    },
    async unarchive_selected_items() {
      let selected_models = this.selected_models.filter(model=>model.archived);
      for(let i=0; i<selected_models.length; i++) {
        await this.set_model_archived(selected_models[i], false);
      }
      this.selected_model_ids = [];
    },
    async delete_item_for_real() {
      this.close_dialog();
      this.loading = true;
      const deletedIds = this.dialog_items_delete.map((model) => model.id);
      try {
        for (let i = 0; i < this.dialog_items_delete.length; i++) {
          await this.$store.dispatch('model/delete', this.dialog_items_delete[i]);
        }
        this.selected_model_ids = this.selected_model_ids.filter(
          (id) => !deletedIds.includes(id),
        );
        this.$emit('models-changed');
      } finally {
        this.loading = false;
        this.dialog_items_delete = [];
      }
    },
    async toggle_model_active(model) {
      if(model.active) {
        await this.$api.model.deactivate(model.id);
        model.active = false;
      }
      else {
        await this.$api.model.activate(model.id);
        model.active = true;
      }
    },
    close_dialog() {
      this.dialog_delete = false
    },
    bundle_download_url(model) {
      return this.$api.model.bundleDownloadUrl(model.id);
    },
    formatDatasetCount(count) {
      if (count === null || count === undefined) {
        return '—';
      }
      return count;
    },
    customFilter (value, search, item) {
      if(search === null || search === undefined || search === '') {
        return true;
      }
      let search_value = String(search).toLowerCase().trim();
      if(search_value === '') {
        return true;
      }
      let name_value = '';
      if(item && item.name) {
        name_value = String(item.name).toLowerCase();
      }
      if(name_value.includes(search_value)) {
        return true;
      }
      if(value === null || value === undefined) {
        return false;
      }
      return String(value).toLowerCase().includes(search_value);
    }
  },
  watch: {
    dialog_delete (val) {
        val || this.close_dialog()
    },
  },
  computed: {
    filter_models() {
      let this2 = this;
      return this.models.filter(model=>{
        if(this2.all_models_ids.indexOf(model.id) === -1) {
          return false;
        }
        if(!this2.show_archived && model.archived) {
          return false;
        }
        return true;
      })
    },
    selected_models() {
      return this.models.filter(model=>{
        return this.selected_model_ids.indexOf(model.id) !== -1;
      });
    },
    has_archived_selected() {
      return this.selected_models.some(model=>model.archived);
    },
    has_unarchived_selected() {
      return this.selected_models.some(model=>!model.archived);
    },
    all_models_ids() {
      return this.$store.getters['model/get_items'].map(model=>{return model.id});
    },
    table_headers() {
      return vuetifyHeaders([
        { text: this.$t('modellist.name'), value: 'name' },
        { text: this.$t('modellist.active'), value: 'active' },
        { text: this.$t('modellist.meta'), value: 'meta' },
        { text: this.$t('modellist.dataset'), value: 'dataset', sortable: false },
        { text: this.$t('modellist.performance'), value: 'performance' },
        {
          text: this.$t('modellist.created_at'),
          value: 'created_at',
          sort: (a, b) => dayjs(a).unix() < dayjs(b).unix(),
        },
        { text: this.$t('modellist.actions'), value: 'actions', sortable: false },
        { text: this.$t('modellist.download'), value: 'exports', sortable: false },
      ]);
    },
  },
}
</script>

<style scoped>

</style>